// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash/fp';

// Utils
import {
    getAssignments,
    getElementId,
    getShowAssignments,
} from '../../../../common/elements/utils/elementPropertyUtils';
import { prop } from '../../../../common/utils/immutableHelper';

// Components
import TaskAssignmentPill from './TaskAssignmentPill';

const TaskAssignmentPanel = (props) => {
    const { element, isEditable } = props;

    if (!getShowAssignments(element)) return null;

    const assignments = getAssignments(element);
    const elementId = getElementId(element);

    return (
        <div className="TaskAssignmentPanel">
            {isEmpty(assignments) ? (
                <TaskAssignmentPill
                    popupId={`task-assignment-${elementId}-0`}
                    elementId={elementId}
                    isEditable={isEditable}
                >
                    Assign to…
                </TaskAssignmentPill>
            ) : (
                assignments.map((assignment, index) => (
                    <TaskAssignmentPill
                        key={index}
                        className="assigned"
                        popupId={`task-assignment-${elementId}-${index}`}
                        assignment={assignment}
                        elementId={elementId}
                        populated
                        {...props}
                    >
                        @{prop('assigneeName', assignment)}
                    </TaskAssignmentPill>
                ))
            )}
        </div>
    );
};

TaskAssignmentPanel.propTypes = {
    element: PropTypes.object,
    isEditable: PropTypes.bool,
};

export default TaskAssignmentPanel;
